module.exports = __webpack_public_path__ + "static/media/sid.80436d06.svg";